import { render, staticRenderFns } from "./DeDate.vue?vue&type=template&id=023556d6&"
import script from "./DeDate.vue?vue&type=script&lang=js&"
export * from "./DeDate.vue?vue&type=script&lang=js&"
import style0 from "./DeDate.vue?vue&type=style&index=0&id=023556d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports